export const TestManagementToolOptions = [
  {
    label: 'Jira Xray Cloud',
    value: 'XRAY_CLOUD'
  },
  {
    label: 'Jira Zephyr',
    value: 'ZEPHYR_CLOUD'
  }
  // TODO: enable when implemented
  // { label: 'Testrail', value: 'TESTRAIL' }
]
